module.exports = __webpack_public_path__ + "img/visa.60f4488b.svg";